import { addLocaleData } from 'react-intl'
import enLang from './entries/en-US'
import daLang from './entries/da-DK'

const AppLocale = {
  en: enLang,
  da: daLang
}

addLocaleData(AppLocale.en.data)
addLocaleData(AppLocale.da.data)

export const formats = {
  time: {
    '24hourCET': {
      hour12: false,
      timeZone: 'europe/copenhagen'
    }
  }
}

export default AppLocale



// WEBPACK FOOTER //
// ./lngProvider/index.js